import React from "react";
import {Builder} from "../../_metronic/_partials";

export default function BuilderPage() {
    return <Builder />;
}
